import { KasperskyEvent } from '~/shared/helpers/KasperskyEvent';

export default defineNuxtPlugin(() => {
  const { onLoaded } = useScript('/scripts/kaspersky/das.obf.js');

  onLoaded(() => {
    // @ts-expect-error window.kfp
    KasperskyEvent.LOADED.emit({ login_start: () => window.kfp.login_start() });
  });
});